/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Consultar las ordenes de Compra y Facturas de cada procedimiento para un proveedor logeado.
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     27/Nov/2019
*/

import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Proveedor } from 'src/app/models/Proveedor';
import { ApiProcedimientosService } from 'src/app/services/api-procedimientos.service';
import { ApiRegistryService } from 'src/app/services/api-registry.service';
import { ApiDownloadFileService } from 'src/app/services/api-download-file.service';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { ApiAuthService } from 'src/app/services/api-auth.service';
import { Globals } from 'src/app/globals';
import { ApiUploadFileService } from 'src/app/services/api-upload-file.service';
declare var $: any;

@Component({
  selector: 'ordenCompra-producto',
  templateUrl: './ordenCompra-producto.component.html',
  styleUrls: ['./ordenCompra-producto.component.css']
})
export class OrdenCompraProductoComponent implements OnInit {
  datosGrales: any[] = [];
  ordenesCompra: any[] = [];
  facturas: any[] = [];
  facturaID;

  filePDF: FileList;
  fileXML: FileList;
  fileJPG: FileList;
  claveProveedor;
  solicitud;

  @Input() public anio: string;
  @Input() public idProc: string;
  @ViewChild('txtFilePDF', {static: false}) txtFilePDF: ElementRef;
  @ViewChild('txtFileXML', {static: false}) txtFileXML: ElementRef;
  //@ViewChild('txtFileJPG', {static: false}) txtFileJPG: ElementRef;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private apiProcedimientos: ApiProcedimientosService, private apiRegistry: ApiRegistryService,
    private apiDownload: ApiDownloadFileService, private router: Router, private apiAuth: ApiAuthService,
    private apiUpload: ApiUploadFileService, private globals: Globals) {
  }

  ngOnInit() {
    if (isNullOrUndefined(this.anio) || isNullOrUndefined(this.idProc)) {
      this.readOrdenesCompra('');
    }
    else {
      this.readDatosGrales(this.anio, this.idProc);
    }
  }

  readDatosGrales(anio: string, idProcedimiento: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();

    setTimeout(() => {
      $('#mod_procesando').modal('show');
    }, 500);

    $('#texto_error').text('Ocurrió un error al mostrar la información del procedimiento.');

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiProcedimientos.getDatosGralesProv(anio, idProcedimiento, proveedor[0].PK_FKCPRCO).subscribe(data => {
          if(data[0].success){
            this.datosGrales = JSON.parse(data[0].info);
            //console.log("Datos Generales", this.datosGrales);

            this.readOrdenesCompra(anio + '-' + idProcedimiento);
          } else {
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#mod_error').modal('show');
            }, 500);
          }
        },
        error => {
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#mod_error').modal('show');
          }, 500);
        });
      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }

  readOrdenesCompra(folio: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();
    let tipoLicitaciones = this.globals.IND_ORDEN_LICITACIONES;

    this.claveProveedor = '';
    $('#texto_error').text('Ocurrió un error al mostrar la información de Ordenes de Compra.');

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);
        this.claveProveedor = proveedor[0].CLAVEPROV;

        this.apiProcedimientos.getOrdenesCompra(this.claveProveedor, folio, prov.Correo).subscribe(data => {
          if(data[0].success){
            this.ordenesCompra = JSON.parse(data[0].info);
            //console.log("Ordenes Compra", this.ordenesCompra);

            if ($.fn.dataTable.isDataTable('#tbl_ordenes')) {
              $('#tbl_ordenes').DataTable().destroy();
            }
            /***************************************/
            $(document).ready(function () {
              let tbl_ordenes = $('#tbl_ordenes').DataTable({
                //dom: '<"row">ltp',
                //dom: '<"#positionFilter">ltp',
                paging: true,       //Oculta controles y etiquetas de paginación
                searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
                info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
                autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
                processing: true,
                bSort: false,
                renderer: 'bootstrap',
                dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
                "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
                language: {
                  "sSearch": "Buscar:",
                  "sProcessing": "Procesando...",
                  "sLengthMenu": "_MENU_ REGISTROS",
                  "sZeroRecords": "No se encontraron resultados",
                  "sEmptyTable": "Ningún dato disponible en esta tabla",
                  "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                  "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                  "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                  "sInfoPostFix": "",
                  "oPaginate": {
                      "sFirst": "Primero",
                      "sLast": "Último",
                      "sNext": "SIGUIENTE",
                      "sPrevious": "ANTERIOR"
                  },
                  buttons: {
                      pageLength: {
                          _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                          //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                          '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
                      }
                  }
              },
              buttons: [
                    {
                      extend: 'pageLength',
                      className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
                  }
              ],
                ordering: true,
                order: [],
                columnDefs: [{
                  orderable: false,
                  targets: "no-sort",
                }
              ]

              });
              //asoledad: 21/08/2022

              $('#tbl_ordenes tbody').on('click', 'tr', function () {
                var data = $('#tbl_ordenes').DataTable().row(this).data();

                var anio = $(this).closest('tr').find('#hdn_aniopedido').val();
                var pedido = $(this).closest('tr').find('#hdn_cvepedido').val();
                var solic = $(this).closest('tr').find('#hdn_folsol').val();
                //var aniopedido = $(this).closest('tr').find('#hdn_aniopedido').val();
                //var foliopedido = $(this).closest('tr').find('#hdn_cvepedido').val();
                //this.seleccionaOrden(solic, anio, pedido);
                //this.readFacturas(anio, pedido);
              });

              $('#txt_ordenes').on( 'keyup', function () {
                tbl_ordenes.search( this.value ).draw();
              });

              $('#todos').on('change', function() {
                if( $(this).is(':checked') ) {
                    $('#licitaciones').prop('checked', false);
                    tbl_ordenes.columns(8).search('');
                } else {
                  tbl_ordenes.columns(8).search('');
                }
                tbl_ordenes.draw();
              });

              $('#licitaciones').on('change', function() {
                if( $(this).is(':checked') ) {
                    $('#todos').prop('checked', false);
                    tbl_ordenes.columns(8).search(tipoLicitaciones);
                } else{
                  tbl_ordenes.columns(8).search('');
                }
                tbl_ordenes.draw();
              });
              //tbl_ordenes.draw();
            });

            if (this.ordenesCompra.length>0) {
              this.seleccionaOrden(this.ordenesCompra[0].FOLIOSOLIC, this.ordenesCompra[0].ANIOPEDIDO, this.ordenesCompra[0].PKPEDIDO);
            } else {
              setTimeout(() => {
                $('#mod_procesando').modal('hide');
              }, 500);
            }

          } else {
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#mod_error').modal('show');
            }, 500);
          }
        },
        error => {
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#mod_error').modal('show');
          }, 500);
        });
      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }

  readFacturas(anio, idProcedimiento) {
    let prov: Proveedor = this.getProveedor();

     //setTimeout(() => {
     //  $('#mod_procesando').modal('show');
     //}, 500);

    $('#texto_error').text('Ocurrió un error al mostrar la información de Facturas.');

    this.apiProcedimientos.getFacturas(this.claveProveedor, anio, idProcedimiento, prov.Correo).subscribe(data => {
      if(data[0].success){
        this.facturas = JSON.parse(data[0].info);
        //console.log("Facturas", this.facturas);

        /***************************************/
        if ($.fn.dataTable.isDataTable('#tbl_facturas')) {
          $('#tbl_facturas').DataTable().destroy();
        }

        $(document).ready(function () {
          let tbl_facturas = $('#tbl_facturas').DataTable({
            //dom: '<"row">ltp',
            //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ],
            ordering: true,
            order: [],
            columnDefs: [{
              orderable: false,
              targets: "no-sort"
            }]
          });

          $('#txt_facturas').on( 'keyup', function () {
            tbl_facturas.search( this.value ).draw();
          });
        });

        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);

      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }

  getProveedor(): Proveedor{
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();

    if (isNullOrUndefined(prov)) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
      return null;
    } else {
      return prov;
    }
  }

  cargarArchivo(type: string, file: FileList) {
    /*Valida que sea del tipo PDF*/
    if (type == 'PDF'){
      if (file[0].type !== 'application/pdf') {
        setTimeout( () => {
          $('#p_alerta').text('El tipo de archivo seleccionado debe ser PDF.');
          $('#mod_alerta').modal('show');
        },500);

        this.txtFilePDF.nativeElement.value = '';
        return
      }

      this.filePDF = file;
    }

    /*Valida que sea del tipo XML*/
    if (type == 'XML'){
      if (file[0].type !== 'text/xml') {
        setTimeout( () => {
          $('#p_alerta').text('El tipo de archivo seleccionado debe ser XML.');
          $('#mod_alerta').modal('show');
        },500);

        this.txtFileXML.nativeElement.value = '';
        return
      }

      this.fileXML = file;
    }

    /*Valida que sea del tipo JPG*/
    if (type == 'JPG'){
      if (file[0].type !== 'image/jpeg') {
        setTimeout( () => {
          $('#p_alerta').text('El tipo de archivo seleccionado debe ser JPG.');
          $('#mod_alerta').modal('show');
        },500);

        //this.txtFileJPG.nativeElement.value = '';
        return
      }

      this.fileJPG = file;
    }
  }

  clearFile() {
    this.txtFilePDF.nativeElement.value = '';
    this.txtFileXML.nativeElement.value = '';
    //this.txtFileJPG.nativeElement.value = '';
  }

  guardarArchivo() {
    $('#mod_procesando').modal('show');

    /*Valida que se hayan seleccionado todos los files*/
    if ((this.filePDF == undefined || this.filePDF.length == 0) ||
        (this.fileXML == undefined || this.fileXML.length == 0)
        //||(this.fileJPG == undefined || this.fileJPG.length == 0)asoledad: 03/06/2021 no validar la imagen de verificacion
        ) {
      setTimeout( () => {
        $('#p_alerta').text('No se han seleccionado todos los archivos.');
        $('#mod_alerta').modal('show');
        $('#mod_procesando').modal('hide');
      },500);

      this.clearFile();
      return;
    }

    /*Valida que los nombres deban ser iguales*/
    if (this.filePDF[0].name.substring(0, this.filePDF[0].name.length-4) !== this.fileXML[0].name.substring(0, this.fileXML[0].name.length-4)
    //|| this.fileXML[0].name.substring(0, this.fileXML[0].name.length-4) !== this.fileJPG[0].name.substring(0, this.fileJPG[0].name.length-4)
        ){
      setTimeout( () => {
        $('#p_alerta').text('Los nombres de los archivos deben ser iguales.');
        $('#mod_alerta').modal('show');
        $('#mod_procesando').modal('hide');
      },500);

      this.clearFile();
      return;
    }

    this.registraFactura(this.anio, this.idProc);
  }

  seleccionaOrden (solicitud, anio, idProcedimiento) {
    this.solicitud = solicitud;
    this.readFacturas(anio, idProcedimiento);

    this.anio = anio;
    this.idProc = idProcedimiento;
  }

  downloadFile(id: string, nombre: string) {
    this.apiDownload.downloadFile(id, true).subscribe(result => {
      var url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

  registraFactura(anio, idProcedimiento) {
    let prov: Proveedor = this.getProveedor();

    $('#mod_procesando').modal('show');
    $('#texto_error').text('Ocurrió un error al registrar la Factura.');

    this.apiUpload.uploadFacturas(anio, idProcedimiento,this.globals.MOVTO_ALTA_FACTURA, '0', this.filePDF[0], this.fileXML[0], null/*this.fileJPG[0]*/).subscribe(data => {
      if(data[0].success){
        this.facturaID = JSON.parse(data[0].info);
        //console.log("Factura nueva ID: ", this.facturas);

        setTimeout( () => {
          $('#h_exito').text('¡Los documentos han sido cargados exitosamente!');
          $('#mod_procesando').modal('hide');
          $('#mod_exito').modal('show');
        },500);

        this.clearFile();

        this.readFacturas(anio, idProcedimiento);
      } else {

        this.clearFile();

        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      this.clearFile();
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }

  reporteCompra(anio:string,folio: string) {
    let nombreReporte = 'FKPEDIDPRO';
    window.open(this.globals.BASE_URL_REPORTE + `ReportViewer.aspx?idusuario=A&token=A&s_perfil=1&s_nombreReporte=${ nombreReporte }&s_parametrosReporte=${ anio }-${ folio }`, '_blank');
  }

  deleteFactura(fadenli) {
    let prov: Proveedor = this.getProveedor();

    $('#mod_procesando').modal('show');
    $('#texto_error').text('Ocurrió un error al borrar la Factura.');

    this.apiUpload.uploadFacturas(this.anio, this.idProc, this.globals.MOVTO_BORRAR_FACTURA, fadenli).subscribe(data => {
      if(data[0].success){
        //this.facturaID = JSON.parse(data[0].info);
        //console.log("Factura eliminada: ", this.facturas);

        setTimeout( () => {
          $('#h_exito').text('¡La factura ha sido eliminada exitosamente!');
          $('#mod_procesando').modal('hide');
          $('#mod_exito').modal('show');
        },500);

        this.readFacturas(this.anio, this.idProc);
      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }
}
